import React, { useState } from "react";
import { Select, DatePicker, Slider, Button } from "antd";
import dayjs from "dayjs";
import { Sidebar } from "react-pro-sidebar";

const { Option } = Select;
const { RangePicker } = DatePicker;

const AdminSideBar: React.FC = () => {
  const [ageRange, setAgeRange] = useState<[number, number]>([0, 120]);

  const handleAgeRangeChange = (value: [number, number] | number[]) => {
    if (Array.isArray(value) && value.length === 2) {
      setAgeRange([value[0], value[1]]);
    }
  };

  const currentDate = dayjs();
 
  return (
    <>
      <h2 style={{ color: "#fff", marginBottom: "20px" }}>Filters</h2>

      <div className="admin-sidebar-menu">
        <label style={{ marginBottom: "8px", display: "block" }}>Workers</label>
        <Select defaultValue="All Workers" style={{ width: "100%" }}>
          <Option value="all">All Workers</Option>
        </Select>
      </div>
      <div className="admin-sidebar-menu">
        <label style={{ marginBottom: "8px", display: "block" }}>Date</label>
        <RangePicker
           defaultValue={[
            currentDate.subtract(30, 'day'), 
            currentDate,                    
          ]}
          format="DD/MMM/YYYY"
          style={{ width: "100%" }}
        />
      </div>

      <div className="admin-sidebar-menu">
        <label style={{ marginBottom: "8px", display: "block" }}>
          Age (0-120)
        </label>
        <Slider
          range
          min={0}
          max={120}
          step={20}
          defaultValue={ageRange}
          marks={{
            0: "0",
            20: "20",
            40: "40",
            60: "60",
            80: "80",
            100: "100",
            120: "120",
          }}
          onChange={handleAgeRangeChange}
          className="admin-sidebar-menu"
        />
        <div
          className="age-wise-filter-button"
          style={{
            display: "flex",
            justifyContent: "space-around",
            alignItems: "center",
          }}
        >
          <Button type="primary" shape="round">
            18 - 29 Yrs
          </Button>
          <Button type="primary" shape="round">
            30 - 44 Yrs
          </Button>
          <Button type="primary" shape="round">
            30+ Yrs
          </Button>
          <Button type="primary" shape="round">
            45+ Yrs
          </Button>
        </div>
      </div>

      <div className="admin-sidebar-menu">
        <label style={{ marginBottom: "8px", display: "block" }}>Gender</label>
        <Select defaultValue="all" style={{ width: "100%" }}>
          <Option value="all">All</Option>
          <Option value="male">Male</Option>
          <Option value="female">Female</Option>
        </Select>
      </div>

      <div className="admin-sidebar-menu">
        <label style={{ marginBottom: "8px", display: "block" }}>
          View Readings by Workers
        </label>
        <Select defaultValue="All readings" style={{ width: "100%" }}>
          <Option value="all">All readings</Option>
          {/* Add more options as needed */}
        </Select>
      </div>
    </>
  );
};

export default AdminSideBar;
